// extracted by mini-css-extract-plugin
export default {"pagination":"styles-module__pagination__src-labstep-web-core-Pagination-_foRo9","showing":"styles-module__showing__src-labstep-web-core-Pagination-_Qrx_7"};